export enum OutsideFacilityLocationEnum {
    Home = 1,
    Shelter = 2,
    Family = 3,
    HomelessSetting = 4,
    SoberLiving = 5,
}
